import React, { useState } from 'react';
import { Link2, Copy, Check, Tag } from 'lucide-react';
import { ClientEntity } from '../types';

interface Props {
  client: ClientEntity;
}

export function UtmGeneratorBoard({ client }: Props) {
  const [copied, setCopied] = useState(false);
  const [source, setSource] = useState('meta_ads');
  const [campaign, setCampaign] = useState('');
  
  const baseUrl = client.data.website || `https://${client.slug}.dithosites.com`;
  
  let finalUrl = baseUrl;
  if (source || campaign) {
    const url = new URL(baseUrl.startsWith('http') ? baseUrl : `https://${baseUrl}`);
    if (source) url.searchParams.set('utm_source', source);
    if (campaign) url.searchParams.set('utm_campaign', campaign);
    url.searchParams.set('utm_medium', 'nyroh_system');
    finalUrl = url.toString();
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(finalUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="space-y-6 animate-in fade-in duration-500">
      <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-5 flex items-start gap-4">
        <div className="p-2 bg-emerald-100 rounded-lg text-emerald-600 shrink-0">
          <Tag size={24} />
        </div>
        <div>
          <h4 className="text-emerald-900 font-semibold mb-1">Inteligência de Rastreamento (X9)</h4>
          <p className="text-sm text-emerald-700">
            A injeção de UTM permite que o CRM saiba exatamente de onde cada lead veio. O formulário do site já está preparado para ler esses links automaticamente e salvar no banco de dados.
          </p>
        </div>
      </div>

      <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm max-w-2xl">
        <h3 className="font-semibold text-gray-900 mb-4">Gerador de Link Rastreado</h3>
        
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">URL Base (Site do Cliente)</label>
            <input 
              type="text" 
              value={baseUrl}
              disabled
              className="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2 text-sm text-gray-500"
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Origem (utm_source)</label>
              <select 
                value={source}
                onChange={e => setSource(e.target.value)}
                className="w-full border border-gray-300 focus:border-black rounded-lg px-4 py-2 text-sm outline-none"
              >
                <option value="meta_ads">Facebook / Instagram Ads</option>
                <option value="google_ads">Google Ads</option>
                <option value="tiktok_ads">TikTok Ads</option>
                <option value="whatsapp">Link do WhatsApp</option>
                <option value="bio_instagram">Bio do Instagram</option>
              </select>
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Campanha (opcional)</label>
              <input 
                type="text" 
                placeholder="Ex: black_friday"
                value={campaign}
                onChange={e => setCampaign(e.target.value)}
                className="w-full border border-gray-300 focus:border-black rounded-lg px-4 py-2 text-sm outline-none"
              />
            </div>
          </div>

          <div className="pt-4 border-t border-gray-100">
            <label className="block text-sm font-medium text-gray-700 mb-1">Link Final Gerado (Copie e use nos anúncios)</label>
            <div className="flex items-center gap-2">
              <div className="flex-1 bg-gray-50 border border-gray-200 rounded-lg px-4 py-3 text-sm font-mono text-gray-600 overflow-hidden text-ellipsis whitespace-nowrap">
                {finalUrl}
              </div>
              <button 
                onClick={handleCopy}
                className="bg-black hover:bg-gray-800 text-white p-3 rounded-lg transition-colors flex items-center justify-center shrink-0"
                title="Copiar link"
              >
                {copied ? <Check size={18} /> : <Copy size={18} />}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
